"use client";
import React from "react";
import { Flex, Radio } from "antd";
import Link from "next/link";
import { FaPhoneVolume, FaYoutube } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { useSelector } from "react-redux";

export default function HelpSection() {
  const setting = useSelector((state) => state.setting.data);

  return (
    <section
      className="help_section section_padding"
      style={
        {
          // backgroundImage: "url('/images/home-page/help-bg-pattern.avif')",
        }
      }
    >
      <div className="container">
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 md:gap-6 gap-4">
          <div
            className="help-card bg-pattern"
            style={{ backgroundImage: "url('/images/home-page/pattern.avif')" }}
          >
            <h2 className="help-title">যেকোনো প্রয়োজনে আমাদেরকে কল করো</h2>
            {setting?.phone_1 && (
              <Link href={`tel:${setting.phone_1}`} className="help-button">
                <span className="icon">
                  <FaPhoneVolume />
                </span>{" "}
                কল করো
              </Link>
            )}
          </div>

          <div
            className="help-card bg-pattern help-video-card"
            style={{ backgroundImage: "url('/images/home-page/pattern.avif')" }}
          >
            <h2 className="help-title">ফ্রি ভিডিও দেখো</h2>
            {setting && (
              <a
                href={setting?.youtube ?? "#"}
                className="help-button help-video-button"
                target="_blank"
              >
                <span className="icon">
                  <FaYoutube />{" "}
                </span>{" "}
                ভিডিও দেখো
              </a>
            )}
          </div>

          <div
            className="help-card bg-pattern"
            style={{ backgroundImage: "url('/images/home-page/pattern.avif')" }}
          >
            <h2 className="help-title">ফোকাসের ফেসবুক গ্রুপে এখনিযুক্ত হও</h2>
            {setting && (
              <a
                href={setting?.facebook ?? "#"}
                className="help-button"
                target="_blank"
              >
                <span className="icon fb-icon">
                  <FaFacebookF />
                </span>
                গ্রুপে যুক্ত হও{" "}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
